import { useState } from "react";
import HttpClient from "../utils/HttpClient";

const MemberProductsUpdateModal = ({ closemodal, data, setData, updateForm, setSaveEditedData }) => {
  const [formData, setFormData] = useState(data);
  const [errors, setErrors] = useState({});
  const initProduct = {
    "name": "",
    "description": "",
    "image": ""
  }
  const [error, setError] = useState("");

  const validate = () => {
    let isValid = true;
    const error = {};

    if (!formData?.productData) {
      error.productData = "Please enter product data.";
      isValid = false;
    }

    setErrors(error);
    return isValid;
  };

  const submit = () => {
    if (validate()) {
      setData({
        ...data,
        ...formData,
      });
      setSaveEditedData(true);
      closemodal();
    }
  };

  const handleAddMore = () => {
    const newData = [...formData.productData, { ...initProduct }];
    setFormData(prev => ({ ...prev, productData: newData }));
  }

  const handleProductChange = (e, i) => {
    // e.preventDefault();
    const { name, value } = e.target
    const newData = formData.productData?.map((ele, ind) => {
      if (i === ind) {
        return { ...ele, [name]: value }
      } else {
        return ele
      }
    });
    setFormData(prev => ({ ...prev, productData: newData }))
  }

  const handleImage = async (e, i) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate file type
    const validImageTypes = ["image/jpeg", "image/png", "image/jpg"];
    if (!validImageTypes.includes(file.type)) {
      setError(prev => Array.isArray(prev) ? [...prev, { index: i, message: "Error: Please upload a valid image file (PNG/JPEG)" }] : [{ index: i, message: "Error: Please upload a valid image file (PNG/JPEG)" }]);
      return;
    }

    // Validate file size (5MB = 5242880 bytes)
    const maxSize = 5 * 1024 * 1024;
    if (file.size > maxSize) {
      setError(prev => Array.isArray(prev) ? [...prev, { index: i, message: "Error: File size must be less than or equal to 5MB" }] : [{ index: i, message: "Error: File size must be less than or equal to 5MB" }]);
      return;
    }

    let formData = new FormData()
    formData.append("image", file)
    const res = await HttpClient.fileUplode("image-upload", "POST", formData);
    if (res && res?.status) {
      handleProductChange({ target: { name: "image", value: res?.data?.url } }, i)
    } else {
      setError(prev => Array.isArray(prev) ? [...prev, { index: i, message: res?.message }] : [{ index: i, message: res?.message }]);
    }
  }

  const removeProducts = (i) => {
    const newData = formData.productData?.filter((ele, ind) => i !== ind)
    setFormData(prev => ({ ...prev, productData: newData }))
  }

  return (

    <div className="uploabannermodalbgshadow">
      <div className="compamyinfoeditbgmain">
        <h5 className="mt-2 p-0 m-3">Update Products</h5>
        <hr />
        <div className="crossdivicon" onClick={() => closemodal()} style={{ cursor: "pointer" }}>
          <i className="fa-solid fa-xmark"></i>
        </div>
        <div className="eidutcommhifnnfodivdibvamain">
          <div className="">
            <div className="pl-4 pr-4">
              <div className="compamydinfodivmain">
                {formData?.productData?.map((item, i) => {
                  return (
                    <div className="compamydinfodivmainbtm border p-2 mt-2 bg-light" key={i}>
                      <p className="conattaindptxtppnewallasa">Product Name</p>
                      <input
                        type="text"
                        className="mt-1 form-control"
                        name="name"
                        value={item.name}
                        onChange={(e) => handleProductChange(e, i)}
                      />

                      <p className="conattaindptxtppnewallasa mt-2">Product Description</p>
                      <textarea
                        rows="3"
                        type="text"
                        className="form-control"
                        placeholder="Enter Product Description"
                        name="description"
                        value={item?.description}
                        onChange={(e) => handleProductChange(e, i)}
                      />
                      <p className="conattaindptxtppnewallasa mt-2">Product Image</p>
                      <input
                        key={i}
                        type="file"
                        className="mt-1 "
                        name="image"
                        accept="image/*"
                        onChange={(e) => handleImage(e, i)}
                      />
                      <span className="float-right" style={{ cursor: "pointer", marginTop: "55px" }} onClick={() => removeProducts(i)}> <i className="fa fa-trash" /> </span>
                      {item?.image && (
                        <img src={item?.image} alt="" id='preview' height="70px" width="70px" className='mb-2' />
                      )}
                      {error && Array.isArray(error) && error.some(e => e.index === i) && (
                        <div className="error">{error.find(e => e.index === i)?.message}</div>
                      )}
                    </div>
                  );
                })}
              </div>
              <span onClick={handleAddMore}><i className="fa fa-plus border p-2 mt-2"></i></span>
              {errors.productData && (
                <span className="error">{errors.productData}</span>
              )}
            </div>

          </div>

          <div className="eidutcommhifnnfodiv mt-2">
            <div className="svavtatvvbtnnmddsupscftt">
              <button
                className="svavtatvvbtnnm"
                onClick={() => {
                  submit();
                }}
              >
                Save
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};
export default MemberProductsUpdateModal;
